import React, { useState } from 'react'
import { MAX_ARTWORK_QUANTITY } from './artworkSource'

export default function ArtworkQuantityInput({ value, disabled, min = 0, onCommit, onFocus, ...props }) {
  const [draft, setDraft] = useState(null)
  const commit = () => {
    if (draft === null) return
    const number = Number(draft)
    setDraft(null)
    if (!disabled && draft.trim() !== '' && Number.isInteger(number) &&
        number >= min && number <= MAX_ARTWORK_QUANTITY && number !== value) {
      onCommit(number)
    }
  }

  return <input {...props} type="number" min={min} max={MAX_ARTWORK_QUANTITY} step="1"
    value={draft ?? value} disabled={disabled}
    onFocus={event => {
      event.currentTarget.select()
      onFocus?.(event)
    }}
    onChange={event => setDraft(event.target.value)} onBlur={commit}
    onKeyDown={event => {
      if (event.key === 'Enter') {
        event.preventDefault()
        event.currentTarget.blur()
      } else if (event.key === 'Escape') {
        event.preventDefault()
        event.stopPropagation()
        setDraft(null)
      }
    }} />
}
